import { api } from '.'

export const buyCardApi = api.injectEndpoints({
  endpoints: build => ({
    apply: build.mutation({
      query: ({ mobile_phone }) => ({
        url: `/mega_cards/application/apply/`,
        method: 'POST',
        body: { mobile_phone }
      })
    }),
    getProducts: build.query({
      query: () => ({
        url: `/mega_cards/products/`,
        method: 'GET'
      })
    }),
    orderCard: build.mutation({
      query: ({ product_code }) => ({
        url: `/mega_cards/products/landing-order/`,
        method: 'POST',
        body: { product_code }
      })
    }),
    getPrepaidGeneralInfo: build.query({
      query: () => ({
        url: `/prepaid/general-info/`,
        method: 'GET'
      })
    })
  })
})

export const { useApplyMutation, useGetProductsQuery, useOrderCardMutation, useGetPrepaidGeneralInfoQuery } = buyCardApi
